import React, { useState } from 'react';

import { ConfigSwitchSection, ParentAwareSaveBar } from '../../../common';
import { inheritableLabelsFromConfigNames } from '../../../util/parentSettingSave';
import { ConfigResponse } from '../../../store/modules/merchant/types';

type Props = {
  readOnly?: boolean;
  isSaving?: boolean;
  onSave: (disallowCartEdits: boolean) => Promise<void>;
  disallowCartEditsConfig?: ConfigResponse<boolean>;
};

export const CartEditsContent = ({
  onSave,
  disallowCartEditsConfig,
  readOnly = false,
  isSaving = false,
}: Props) => {
  const [allowCartEdits, setAllowCartEdits] = useState(!disallowCartEditsConfig?.value);

  const isSaveBarOpen = allowCartEdits !== !disallowCartEditsConfig?.value;

  const resetValues = () => {
    setAllowCartEdits(!disallowCartEditsConfig?.value);
  };

  const handleSave = async () => {
    await onSave(!allowCartEdits);
  };

  return (
    <>
      <ConfigSwitchSection
        title="Cart Edits"
        description="Enable/Disable Cart Edits"
        isChecked={allowCartEdits}
        onToggle={() => setAllowCartEdits(!allowCartEdits)}
        disabled={readOnly}
        plural
        switchTestId="CART_EDITS_SWITCH"
      />
      <ParentAwareSaveBar
        disableSave={readOnly || isSaving}
        saveLoading={isSaving}
        show={isSaveBarOpen && !readOnly}
        onCancel={() => resetValues()}
        inheritableSettingLabels={
          isSaveBarOpen ? inheritableLabelsFromConfigNames(['DISALLOW_CART_EDITS']) : []
        }
        onSave={handleSave}
      />
    </>
  );
};
